import { gameState } from "appworks/model/game-state";
import { commsManager } from "appworks/server/comms-manager";
import { Contract } from "appworks/utils/contracts/contract";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { GambleRequestPayload } from "slotworks/model/gameplay/requests/gamble-request-payload";

export function GambleCollectCommand(): Contract<void> {
    const record: SpinRecord = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;
    if (record.gamble) {
        record.gamble = false;

        const payload = new GambleRequestPayload();
        payload.id = (gameState.getCurrentGame().getCurrentRecord() as SpinRecord).gambleID;

        return commsManager.request(payload);
    } else {
        return Contract.empty();
    }
}
